import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export interface FeedbackData {
    rating: number
    comment: string
    category: string
    nps: number
}

export const submitFeedback = async (
    callHeaderId: string | number,
    data: FeedbackData
): Promise<any> => {
    const serializedComment = `[Category: ${data.category}] [NPS: ${data.nps}] ${data.comment}`

    const numericId = String(callHeaderId).replace(/[^0-9]/g, '')

    const payload = {
        Rating: data.rating,
        Comment: serializedComment,
    }

    const response = await axios.post(
        `${API_URL}/AWSConnect/call-log-interpreter-rating/${numericId}`,
        payload
    )

    return response.data
}